exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-block>div[data-v-3fdb5413]{margin-bottom:20px}.demo-block>div[data-v-3fdb5413]:last-child{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fdb5413","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./src/docs/button.md
// module id = 4BMl
// module chunks = 0